import React, { Component } from 'react';
import '../App.css';

var months=['תשרי','חשוון','כסלו','טבת','שבט','אדר','ניסן','אייר','סיוון','תמוז','אב','אלול'];
class DropdownMonth extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showMenu: false,
      month: this.props.currentMonth
    };
    
    this.generateDropdownItems = this.generateDropdownItems.bind(this);
    this.showCloseMenu = this.showCloseMenu.bind(this);
  }
  
  showCloseMenu(event) {
    event.preventDefault();
    this.setState({ showMenu: !this.state.showMenu });
  }
  
  chooseMonth(event){
    this.setState({month: months[parseInt(event.target.id.slice(2))], showMenu:false});
    this.props.updateMonth(months[parseInt(event.target.id.slice(2))]);
  }

  generateDropdownItems(){
    let buttons =[];
    if(this.props.isLeapYear)
    {
        if(months.length===12)
            months.splice(5, 1 ,'אדר א', 'אדר ב');
    }
    else{
        if(months.length>12)
            months.splice(5, 2, 'אדר');
    }
    for(let i=0;i<months.length;i++)
    {
        buttons.push(<button className="dropdown-item" id={"bm"+i} key={i} onClick={this.chooseMonth.bind(this)}>{months[i]}</button>);
    }
    return buttons;
  }

  render() {
    return (
      <div>
        <button className="btn dropdown-toggle" onClick={this.showCloseMenu}>
          {"  "+this.state.month+"  "}
        </button>
        
        {
          this.state.showMenu
            ? (
              <div>
                <div className="overlay" onClick={this.showCloseMenu}></div>
                <div className="dropdown-menu" >
                  {this.generateDropdownItems()}
                </div>
                </div>
            )
            : (
              null
            )
        }
      </div>
    );
  }
}

export default DropdownMonth;


// WEBPACK FOOTER //
// ./src/components/DropdownMonth.js